import { render, staticRenderFns } from "./fsBlockAssets.vue?vue&type=template&id=3ca77bcb&scoped=true"
import script from "./fsBlockAssets.vue?vue&type=script&lang=js"
export * from "./fsBlockAssets.vue?vue&type=script&lang=js"
import style0 from "./fsBlockAssets.vue?vue&type=style&index=0&id=3ca77bcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca77bcb",
  null
  
)

export default component.exports